import { keys } from './keys';

export const es = {
  [keys.form.seoDescription]: 'Contacta con nosotros para unirte a nuestro equipo. Decal Spain SAU ',
  [keys.form.fullname]: 'Nombre Completo',
  [keys.form.email]: 'Email',
  [keys.form.interestAreas]: 'Áreas de Interés',
  [keys.form.message]: 'Mensaje',
  [keys.form.resume]: 'Currículum',
  [keys.form.acceptPrivacyPolicy]: 'He leído y acepto la <0>Política de Privacidad</0>',
  [keys.form.button]: 'Enviar',
  [keys.snackbar.success]: '¡Gracias por contactar con nosotros!',
  [keys.snackbar.error]: 'Por favor, inténtelo más tarde, algo ha ido mal :(',
};
